<template>
  <div class="row bg-light justify-content-center m-0">
    <div class="col-12 text-center p-5">
      <h2 class="section-title-steps">SPRENDIMAI PER 3 ŽINGSNIUS</h2>
      <div class="row justify-content-center p-3">
        <div class="section-divider-steps"></div>
      </div>

      <div class="row justify-content-center m-0 steps-container">

        <div class="col-md-4 mb-4">
          <div class="step-card">
            <div class="step-number">01</div>
            <h6 class="step-title">Identifikacija</h6>
            <p class="step-text">Siekiame kuo greičiau suprasti problemą ir pašalinti ją.</p>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="step-card">
            <div class="step-number">02</div>
            <h6 class="step-title">Veiksmas</h6>
            <p class="step-text">Atliekame darbą sklandžiai, o atsiradus daugiau klausimų iš kliento, jam pravedame nemokamą konsultaciją bet kuriuo aktualiu klausimu.</p>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="step-card">
            <div class="step-number">03</div>
            <h6 class="step-title">Rezultatas</h6>
            <p class="step-text">Įvykdžius remontą, susisieksime su savininku.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EasySteps"
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,500;1,300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&display=swap');

.section-title-steps {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  font-weight: 800;
  color: #1a1a1a;
  padding-top: 40px;
  letter-spacing: -0.02em;
}

.section-divider-steps {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  border-radius: 2px;
  margin: 0 auto;
}

.steps-container {
  padding: 20px 0;
}

.step-card {
  background: white;
  border-radius: 16px;
  padding: 40px 30px;
  height: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
  position: relative;
  overflow: hidden;
}

.step-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #dc3545, #ff6b6b);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.step-card:hover::before {
  transform: scaleY(1);
}

.step-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  border-color: #dc3545;
}

.step-number {
  font-family: 'Montserrat', sans-serif;
  font-size: 4rem;
  font-weight: 800;
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;
  margin-bottom: 20px;
  opacity: 0.2;
  transition: opacity 0.3s ease;
}

.step-card:hover .step-number {
  opacity: 0.3;
}

.step-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 16px;
}

.step-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;
  line-height: 1.7;
  color: #6c757d;
  margin: 0;
}

@media (max-width: 768px) {
  .step-card {
    padding: 30px 24px;
  }
  
  .step-number {
    font-size: 3rem;
  }
}
</style>